import { h, Component } from 'preact';
import { Form, Validators, validateField } from '../utils/form-helpers';
import modalContent from '../constants/modalContent';
import SignInWith from './SignInWith';
import FieldWrapper from './generics/FieldWrapper';
import ButtonWrapper from './generics/ButtonWrapper';
import AlertMessage from './generics/AlertMessage';

const EMAIL_FIELD = 'email';
const PASSWORD_FIELD = 'password';

export default class SignInContent extends Component {
  constructor () {
    super();
    this.state = {
      error: '',
      isLoading: false,
      form: new Form({
        [PASSWORD_FIELD]: {
          value: '',
          validators: [Validators.required()],
        },
        [EMAIL_FIELD]: {
          value: '',
          validators: [Validators.required(), Validators.email()],
        },
      }),
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount () {
    const { form } = this.state;
    form.clearValues(this);
  }

  onSubmit () {
    const { form } = this.state;
    const { session, mixpanelTracker } = this.props;
    const { pub } = window.reservamosPubSub;

    this.setState({
      isLoading: true,
      error: '',
    });

    session
      .signIn({
        email: form.getValue(EMAIL_FIELD),
        password: form.getValue(PASSWORD_FIELD),
      })
      .then((user) => {
        mixpanelTracker.trackSignIn({
          'Siempre Plus Card': user.sp_card,
          'Type': 'Siempre Plus Card',
        });

        this.setState({ isLoading: false });
        pub('siempreplus', {
          user,
          loading: false,
          error: null,
        });
      })
      .catch(({ response }) => {
        this.setState({ isLoading: false });
        response
          .json()
          .then(({ errors: [error] }) => {
            pub('siempreplus', {
              loading: false,
              user: null,
              error,
            });
            this.setState({ error: error.message });
          })
          .catch((error) => {
            console.error(error);
            pub('siempreplus', {
              loading: false,
              user: null,
              error,
            });
            this.setState({ error: 'Un error inesperado ha ocurrido' });
          });
      });
  }

  render ({ onChangeContent, mixpanelTracker }) {
    const { form, isLoading, error } = this.state;

    const signInWithCallback = type => mixpanelTracker.trackSignIn({
      'Siempre Plus Card': null,
      'Type': type,
    });

    return (
      <div>
        <form onSubmit={form.onSubmit(this, this.onSubmit)}>
          <AlertMessage type="error" visible={Boolean(error)}>
            {error}
          </AlertMessage>
          <FieldWrapper
            hasError={form.fieldHasErrors(EMAIL_FIELD)}
            className="form-item"
            errorLegend="Por favor escriba un correo válido"
          >
            <input
              type="text"
              placeholder="Correo electrónico"
              name={EMAIL_FIELD}
              onInput={validateField(this, form)}
            />
          </FieldWrapper>
          <FieldWrapper
            hasError={form.fieldHasErrors(PASSWORD_FIELD)}
            className="form-item"
            errorLegend="Campo requerido"
          >
            <input
              type="password"
              placeholder="Contraseña"
              name={PASSWORD_FIELD}
              onInput={validateField(this, form)}
            />
          </FieldWrapper>
          <div className="form-item">
            <p className="w-modal-copy forgot-link">
              {/* eslint-disable-next-line */}
              <a
                className="w-modal-link"
                onClick={() => onChangeContent(modalContent.FORGOT_PIN)}
              >
                ¿Olvidaste tu contraseña?
              </a>
            </p>
          </div>
          <div className="form-item">
            <ButtonWrapper
              className="w-modal-button"
              type="submit"
              isLoading={isLoading}
            >
              Iniciar sesión
            </ButtonWrapper>
          </div>
        </form>
        <SignInWith onSelect={signInWithCallback} />
        <div>
          <p className="w-modal-copy account-link">
            {/* eslint-disable-next-line */}
            <a
              className="w-modal-link"
              onClick={() => onChangeContent(modalContent.SIGN_UP)}
            >
              {'¿No tienes cuenta? '}
              <span>Registrate</span>
            </a>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SignInContent.js